import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { Flex } from 'components/styled/Flex';
import { useAuthState } from 'services/auth/AuthContext';

const ACCESS_TOKEN = 'accessToken';
const REFRESH_TOKEN = 'refreshToken';

export const TokenLogin = () => {
  const [searchParams] = useSearchParams();
  const { setTokens } = useAuthState();
  const { t } = useTranslation();

  useEffect(() => {
    if (searchParams.has(ACCESS_TOKEN) && searchParams.has(REFRESH_TOKEN)) {
      const accessToken = searchParams.get(ACCESS_TOKEN)?.replace('Bearer ', '');
      const refreshToken = searchParams.get(REFRESH_TOKEN);
      if (accessToken && refreshToken) {
        setTokens(accessToken, refreshToken);

        if (searchParams.has('redirectUrl')) {
          const redirectUrl = searchParams.get('redirectUrl');
          window.location.href = redirectUrl || '/dashboard';

          return;
        }

        if (searchParams.has('propertyId')) {
          const propertyId = searchParams.get('propertyId');
          window.location.href = `/accommodations/rentals/${propertyId}/rental-preview`;
        } else {
          window.location.href = '/dashboard';
        }
      }
    }
  }, []);

  return <Flex>{t('Redirecting...')}</Flex>;
};
